import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';

const Thanks = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl w-full bg-white shadow-xl rounded-lg p-12 text-center"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
          className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6"
        >
          <CheckCircle className="h-12 w-12 text-green-600" />
        </motion.div>

        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
          Thank You!
        </h1>
        
        <p className="text-xl text-slate-600 mb-8">
          We've received your information and will contact you shortly.
        </p>

        <div className="bg-slate-50 border border-slate-200 rounded-lg p-6 mb-8">
          <p className="text-slate-700 leading-relaxed">
            One of our experienced attorneys will review your inquiry and reach out to you within 24 hours. 
            We look forward to assisting you with your legal needs.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-8 py-3 bg-slate-900 text-white font-medium rounded hover:bg-slate-800 transition-colors"
          >
            Return to Home
          </Link>
          <Link
            to="/services/corporate-business-contracts"
            className="inline-flex items-center justify-center px-8 py-3 border-2 border-slate-900 text-slate-900 font-medium rounded hover:bg-slate-900 hover:text-white transition-colors"
          >
            Explore Our Services
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default Thanks;
